import api from "./axios";
import { convertKeysToSnakeCase } from "../utils/caseConverter";
export const createStore = async ({
  name,
  logo,
  address,
  latitude,
  longitude,
}) => {
  const formData = new FormData();
  formData.append("name", name);
  formData.append("logo", logo);
  formData.append("address", address);
  formData.append("latitude", latitude);
  formData.append("longitude", longitude);

  const response = await api.post("/stores", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const deleteStore = async ({ storeId }) => {
  const response = await api.delete(`/stores/${storeId}`);
  return response.data;
};

export const inviteUser = async ({ storeId, userData }) => {
  const formData = new FormData();
  formData.append("email", userData.email);
  formData.append("role", userData.role);

  const response = await api.post(`/stores/${storeId}/store_users`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const updateStoreUserRole = async ({ storeId, storeUserId, role }) => {
  const response = await api.patch(
    `/stores/${storeId}/store_users/${storeUserId}`,
    {
      role,
    },
  );
  return response.data;
};

export const removeStoreUser = async ({ storeId, storeUserId }) => {
  const response = await api.delete(
    `/stores/${storeId}/store_users/${storeUserId}`,
  );
  return response.data;
};

export const createPassLayout = async ({
  storeId,
  layoutData,
  stampIcon,
  companyLogo,
  backgroundImagesFormData,
  previewImage,
}) => {
  const formData = new FormData();

  // Convert layoutData from camelCase to snake_case
  const snakeCaseLayoutData = convertKeysToSnakeCase(layoutData);

  // Append the layout data as a JSON string
  formData.append("pass", JSON.stringify(snakeCaseLayoutData));

  // Handle company logo
  if (companyLogo) {
    formData.append("company_logo", companyLogo);
  }

  // Handle stamp icon
  if (stampIcon) {
    formData.append("stamp_icon", stampIcon);
  }
  // Handle background image
  if (backgroundImagesFormData) {
    backgroundImagesFormData.forEach((value, key) => {
      formData.append(key, value);
    });
  }

  if (previewImage) {
    formData.append("preview_image", previewImage);
  }

  const response = await api.post(`/stores/${storeId}/passes`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const updatePassLayout = async ({
  storeId,
  passId,
  layoutData,
  stampIcon,
  companyLogo,
  backgroundImagesFormData,
  previewImage,
}) => {
  const formData = new FormData();

  // Convert layoutData from camelCase to snake_case
  const snakeCaseLayoutData = convertKeysToSnakeCase(layoutData);

  // Append the layout data as a JSON string
  formData.append("pass", JSON.stringify(snakeCaseLayoutData));

  if (companyLogo) {
    formData.append("company_logo", companyLogo);
  }

  if (stampIcon) {
    formData.append("stamp_icon", stampIcon);
  }

  if (backgroundImagesFormData) {
    backgroundImagesFormData.forEach((value, key) => {
      formData.append(key, value);
    });
  }

  if (previewImage) {
    formData.append("preview_image", previewImage);
  }

  const response = await api.put(
    `/stores/${storeId}/passes/${passId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const createForm = async ({
  storeId,
  kind,
  passId,
  description,
  submitText,
  content,
  backgroundColor,
  textColor,
}) => {
  const response = await api.post(`/stores/${storeId}/forms`, {
    kind,
    passId,
    description,
    submit_text: submitText,
    pass_id: passId,
    content,
    background_color: backgroundColor,
    text_color: textColor,
  });

  return response.data;
};

export const updateForm = async ({
  storeId,
  formId,
  kind,
  passId,
  description,
  submitText,
  content,
  backgroundColor,
  textColor,
}) => {
  const response = await api.put(`/stores/${storeId}/forms/${formId}`, {
    kind,
    description,
    submit_text: submitText,
    pass_id: passId,
    content,
    background_color: backgroundColor,
    text_color: textColor,
  });

  return response.data;
};

export const submitPublicForm = async ({ formId, data }) => {
  const response = await api.post(`/public/forms/${formId}/submit`, {
    submission: data,
  });
  return response.data;
};

export const deletePassLayout = async ({ storeId, passId }) => {
  const response = await api.delete(`/stores/${storeId}/passes/${passId}`);
  return response.data;
};

export const createFlyer = async ({ storeId, formData }) => {
  const response = await api.post(`/stores/${storeId}/flyers`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateFlyer = async ({ storeId, flyerId, formData }) => {
  const response = await api.put(
    `/stores/${storeId}/flyers/${flyerId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const updateCustomer = async ({ storeId, customerId, data }) => {
  const response = await api.put(
    `/stores/${storeId}/customers/${customerId}`,
    data,
  );
  return response.data;
};

export const deleteCustomer = async ({ storeId, customerId }) => {
  const response = await api.delete(
    `/stores/${storeId}/customers/${customerId}`,
  );
  return response.data;
};

export const createCampaign = async ({ storeId, campaignData }) => {
  const response = await api.post(`/stores/${storeId}/campaigns`, campaignData);
  return response.data;
};

export const updateCampaign = async ({ storeId, campaignId, campaignData }) => {
  const response = await api.put(
    `/stores/${storeId}/campaigns/${campaignId}`,
    campaignData,
  );
  return response.data;
};

export const deleteCampaign = async ({ storeId, campaignId }) => {
  const response = await api.delete(
    `/stores/${storeId}/campaigns/${campaignId}`,
  );
  return response.data;
};

export const createSubscription = async ({ storeId, productId, interval }) => {
  const response = await api.post(`/stores/${storeId}/checkout`, {
    product_id: productId,
    interval: interval,
  });

  return response.data;
};

export const deleteForm = async ({ storeId, formId }) => {
  const response = await api.delete(`/stores/${storeId}/forms/${formId}`);
  return response.data;
};

export const deleteFlyer = async ({ storeId, flyerId }) => {
  const response = await api.delete(`/stores/${storeId}/flyers/${flyerId}`);
  return response.data;
};

export const updateStore = async ({
  storeId,
  name,
  logo,
  address,
  latitude,
  longitude,
}) => {
  const formData = new FormData();
  formData.append("name", name);
  if (logo) {
    formData.append("logo", logo);
  }

  if (address) {
    formData.append("address", address);
  }

  if (latitude && longitude) {
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
  }

  const response = await api.put(`/stores/${storeId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const updateCustomField = async ({ storeId, fieldId, data }) => {
  const response = await api.put(
    `/stores/${storeId}/custom_fields/${fieldId}`,
    data,
  );
  return response.data;
};

export const deleteCustomField = async ({ storeId, fieldId }) => {
  const response = await api.delete(
    `/stores/${storeId}/custom_fields/${fieldId}`,
  );
  return response.data;
};

export const createBranch = async ({
  storeId,
  name,
  address,
  latitude,
  longitude,
}) => {
  const response = await api.post(`/stores/${storeId}/branches`, {
    name,
    address,
    latitude,
    longitude,
  });
  return response.data;
};

export const updateBranch = async ({
  storeId,
  branchId,
  name,
  address,
  latitude,
  longitude,
}) => {
  const response = await api.patch(`/stores/${storeId}/branches/${branchId}`, {
    name,
    address,
    latitude,
    longitude,
  });
  return response.data;
};

export const deleteBranch = async ({ storeId, branchId }) => {
  const response = await api.delete(`/stores/${storeId}/branches/${branchId}`);
  return response.data;
};

export const createNotification = async ({ storeId, notificationData }) => {
  const response = await api.post(
    `/stores/${storeId}/notifications`,
    notificationData,
  );
  return response.data;
};

export const updateNotification = async ({
  storeId,
  notificationId,
  notificationData,
}) => {
  const response = await api.put(
    `/stores/${storeId}/notifications/${notificationId}`,
    notificationData,
  );
  return response.data;
};

export const deleteNotification = async ({ storeId, notificationId }) => {
  const response = await api.delete(
    `/stores/${storeId}/notifications/${notificationId}`,
  );
  return response.data;
};

export const updateUser = async ({ data }) => {
  const response = await api.patch(`/user`, data);
  return response.data;
};

export const connectIntegration = async ({ storeId, integrationData }) => {
  const response = await api.post(
    `/stores/${storeId}/integrations`,
    integrationData,
  );
  return response.data;
};

export const disconnectIntegration = async ({ storeId, integrationId }) => {
  const response = await api.delete(
    `/stores/${storeId}/integrations/${integrationId}`,
  );
  return response.data;
};

export const updateIntegration = async ({
  storeId,
  integrationId,
  integrationData,
}) => {
  const response = await api.put(
    `/stores/${storeId}/integrations/${integrationId}`,
    integrationData,
  );
  return response.data;
};

export const createMessage = async ({ storeId, messageData }) => {
  // Format the data to ensure integration_id is properly passed
  const formattedData = {
    ...messageData,
    integration_id: messageData.integration_id
      ? parseInt(messageData.integration_id, 10)
      : null,
  };

  const response = await api.post(`/stores/${storeId}/messages`, formattedData);
  return response.data;
};

export const updateMessage = async ({ storeId, messageId, messageData }) => {
  // Format the data to ensure integration_id is properly passed
  const formattedData = {
    ...messageData,
    integration_id: messageData.integration_id
      ? parseInt(messageData.integration_id, 10)
      : null,
  };

  const response = await api.put(
    `/stores/${storeId}/messages/${messageId}`,
    formattedData,
  );
  return response.data;
};

export const deleteMessage = async ({ storeId, messageId }) => {
  const response = await api.delete(`/stores/${storeId}/messages/${messageId}`);
  return response.data;
};
